// Versión que muestra la aplicación: la del build (REACT_APP_VERSION, la calcula CI), no la fila de
// ApplicationVersion. La base de QA se restaura a diario desde producción, así que su fila dice la
// versión de producción. Sin REACT_APP_VERSION (en local), se usa la de la base.
// La detección de actualizaciones sigue en App.tsx con la base, hasta P5 (version.json, issue #12).

/** Etiqueta del ambiente según la versión: X.Y.Z-rc.N+sha es QA, X.Y.Z-dev.N+sha es desarrollo. */
export function versionEnvironment(version: string): "QA" | "DEV" | null {
  if (/-rc\./.test(version)) return "QA";
  if (/-dev\./.test(version)) return "DEV";
  return null;
}

export function displayVersion(fallback: string): string {
  return process.env.REACT_APP_VERSION || fallback;
}
